import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashboard'], resolve)
    },
    {
      // 签约面谈
      path: '/signingInterview',
      name: 'signingInterview',
      meta: {
        menu: '/signingInterview',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/signingInterview'], resolve)
    },
    {
      // 签约面谈详情
      path: '/signingInterviewDetail',
      name: 'signingInterviewDetail',
      meta: {
        menu: '/signingInterview'
      },
      component: resolve => require(['@/pages/signingInterview/detail'], resolve)
    },
    {
      // 签约受理
      path: '/signAccept',
      name: 'signAccept',
      meta: {
        menu: '/signAccept',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/signAccept'], resolve)
    },
    {
      // 签约受理详情
      path: '/signAcceptDetail',
      name: 'signAcceptDetail',
      meta: {
        menu: '/signAccept'
      },
      component: resolve => require(['@/pages/signAccept/detail'], resolve)
    },
    {
      // 签约培训
      path: '/signTrain',
      name: 'signTrain',
      meta: {
        menu: '/signTrain',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/signTrain'], resolve)
    },
    {
      // 签约培训详情
      path: '/signTrainDetail',
      name: 'signTrainDetail',
      meta: {
        menu: '/signTrain'
      },
      component: resolve => require(['@/pages/signTrain/detail'], resolve)
    },
    {
      // 签约审核
      path: '/staySign',
      name: 'staySign',
      meta: {
        menu: '/staySign',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/staySign'], resolve)
    },
    {
      // 签约审核详情
      path: '/staySignDetail',
      name: 'staySignDetail',
      meta: {
        menu: '/staySign'
      },
      component: resolve => require(['@/pages/staySign/detail'], resolve)
    },
    {
      // 注册用户
      path: '/certificate',
      name: 'certificate',
      meta: {
        menu: '/certificate',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/certificate'], resolve)
    },
    {
      // 注册用户详情
      path: '/certificateDetail',
      name: 'certificateDetail',
      meta: {
        menu: '/certificate'
      },
      component: resolve => require(['@/pages/certificate/detail'], resolve)
    },
    {
      // 签约异常
      path: '/signAbnormal',
      name: 'signAbnormal',
      meta: {
        menu: '/signAbnormal',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/signAbnormal'], resolve)
    },
    {
      // 签约异常详情
      path: '/signAbnormalDetail',
      name: 'signAbnormalDetail',
      meta: {
        menu: '/signAbnormal'
      },
      component: resolve => require(['@/pages/signAbnormal/detail'], resolve)
    },
    {
      // 证件审核
      path: '/documentAudit',
      name: 'documentAudit',
      meta: {
        menu: '/documentAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/documentAudit'], resolve)
    },
    {
      // 证件审核详情
      path: '/documentAuditDetails',
      name: 'documentAuditDetails',
      meta: {
        menu: '/documentAudit'
      },
      component: resolve => require(['@/pages/documentAudit/detail'], resolve)
    },
    {
      // 银行卡审核
      path: '/bankCardAudit',
      name: 'bankCardAudit',
      meta: {
        menu: '/bankCardAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/bankCardAudit'], resolve)
    },
    {
      // 银行卡审核详情
      path: '/bankCardAuditDetails',
      name: 'bankCardAuditDetails',
      meta: {
        menu: '/bankCardAudit'
      },
      component: resolve => require(['@/pages/bankCardAudit/detail'], resolve)
    },
    {
      // 注册卡审核
      path: '/regisCardAudit',
      name: 'regisCardAudit',
      meta: {
        menu: '/regisCardAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/regisCardAudit'], resolve)
    },
    {
      // 注册卡审核详情
      path: '/regisCardAuditDetails',
      name: 'regisCardAuditDetails',
      meta: {
        menu: '/regisCardAudit'
      },
      component: resolve => require(['@/pages/regisCardAudit/detail'], resolve)
    },
    {
      // 基本法设置
      path: '/basicLawSet',
      name: 'basicLawSet',
      meta: {
        menu: '/basicLawSet',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/basicLawSet'], resolve)
    },
    {
      // 基本法设置详情
      path: '/basicLawInfo',
      name: 'basicLawInfo',
      meta: {
        menu: '/basicLawSet'
      },
      component: resolve => require(['@/pages/basicLawSet/detail'], resolve)
    },
    {
      // 业务员信息
      path: '/agentInfo',
      name: 'agentInfo',
      meta: {
        menu: '/agentInfo',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/agentInfo'], resolve)
    },
    {
      // 业务员信息详情
      path: '/agentInfoDetails/:step/:agentId',
      name: 'agentInfoDetails',
      meta: {
        menu: '/agentInfo'
      },
      component: resolve => require(['@/pages/agentInfo/detail'], resolve)
    },
    {
      // 新增业务员
      path: '/addAgent',
      name: 'addAgent',
      meta: {
        menu: '/agentInfo',
      },
      component: resolve => require(['@/pages/agentInfo/addAgent'], resolve)
    },
    {
      // 保单详情
      path: '/policyDetails/:policyId',
      name: 'policyDetails',
      meta: {
        menu: '/agentInfo'
      },
      component: resolve => require(['@/pages/agentInfo/policy'], resolve)
    },
    {
      // 投保单详情
      path: '/applyDetails/:applyId',
      name: 'applyDetails',
      meta: {
        menu: '/agentInfo'
      },
      component: resolve => require(['@/pages/agentInfo/apply'], resolve)
    },
    {
      // 业务员批量导入
      path: '/importAgent',
      name: 'importAgent',
      meta: {
        menu: '/agentInfo'
      },
      component: resolve => require(['@/pages/agentInfo/import'], resolve)
    },
    {
      // 业务发展管理 - 分配申请
      path: '/developmentApply',
      name: 'developmentApply',
      meta: {
        menu: '/developmentApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/developmentApply'], resolve)
    },
    {
      // 业务发展管理 - 分配申请详情
      path: '/developmentApplyDetails',
      name: 'developmentApplyDetails',
      meta: {
        menu: '/developmentApply'
      },
      component: resolve => require(['@/pages/developmentApply/detail'], resolve)
    },
    {
      // 业务发展管理 - 分配审核
      path: '/developmentAudit',
      name: 'developmentAudit',
      meta: {
        menu: '/developmentAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/developmentAudit'], resolve)
    },
    {
      // 业务发展管理 - 分配审核详情
      path: '/developmentAuditDetails',
      name: 'developmentAuditDetails',
      meta: {
        menu: '/developmentAudit'
      },
      component: resolve => require(['@/pages/developmentAudit/detail'], resolve)
    },
    {
      // 业务发展管理 - 分配查询
      path: '/developmentQuery',
      name: 'developmentQuery',
      meta: {
        menu: '/developmentQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/developmentQuery'], resolve)
    },
    {
      // 签约审核详情
      path: '/developmentQueryDetails/:id',
      name: 'staySignDetail',
      meta: {
        menu: '/developmentQuery'
      },
      component: resolve => require(['@/pages/developmentQuery/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js